import { get, getBlob } from "./client";
import { ApiEndpoint } from "./endpoints";
import { getUnixTimestamp } from "../util/date-utility";

export const requestOccupancyPlanEmail = async (day: Date, email: string) => {
	day.setHours(0, 0, 0, 0);

	await get(ApiEndpoint.OccupancyPlan, null, {
		day: getUnixTimestamp(day),
		type: "email",
		recipient: email
	});
};

export const requestOccupancyListEmail = async (day: Date, email: string) => {
	day.setHours(0, 0, 0, 0);

	await get(ApiEndpoint.OccupancyList, null, {
		day: getUnixTimestamp(day),
		type: "email",
		recipient: email
	});
};

export const requestPreorderedMealsListEmail = async (day: Date, email: string) => {
	day.setHours(0, 0, 0, 0);

	await get(ApiEndpoint.PreorderedMeals, null, {
		day: getUnixTimestamp(day),
		type: "email",
		recipient: email
	});
};

export const requestOccupancyPlanBlob = async (day: Date, areaId: string) => {
	day.setHours(0, 0, 0, 0);

	return await getBlob(ApiEndpoint.OccupancyPlan, null, {
		day: getUnixTimestamp(day),
		type: "blob",
		area: areaId
	});
};

export const requestOccupancyListBlob = async (day: Date, areaId: string) => {
	day.setHours(0, 0, 0, 0);

	return await getBlob(ApiEndpoint.OccupancyList, null, {
		day: getUnixTimestamp(day),
		type: "blob",
		area: areaId
	});
};

export const requestPreorderedMealsListBlob = async (day: Date) => {
	day.setHours(0, 0, 0, 0);

	return await getBlob(ApiEndpoint.PreorderedMeals, null, {
		day: getUnixTimestamp(day),
		type: "blob"
	});
};
